/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { LecturerBriefingJobParams } from './lecturerBriefingJobParams';

/**
 * Request model for lecturer briefing job
 */
export interface RunLecturerBriefingJobRequest {
  type: 'lecturer_briefing';
  params: LecturerBriefingJobParams;
  allowOverlappingJobs?: boolean;
}
